@if (isShowPasswordVisible && typeInput && typeInput === 'password') {
  <div class="show-password text-right">
    <a (click)="toggleVisibility(idName)">{{ 'common.showPassword' | cxTranslate }}</a>
  </div>
}

@if (parentForm) {
  <div
    [formGroup]="parentForm"
    class="input-group {{ componentClass }}"
    [class.is-invalid]="isNotValidFunction ? isNotValidFunction : isNotValid(nameForm)"
        [ngClass]="{
            'has-value': hasValue(),
            range: showControls && typeInput === 'number',
        }">
    @if (label) {
      <label
        for="{{ idName }}"
        class="input-label-value {{ labelClass }}"
        [ngClass]="{ required: isRequired() }">
        {{ label | cxTranslate }}
        @if (label && subLabel) {
          <span class="input-sublabel-value">{{ subLabel | cxTranslate }}</span>
        }
        @if (labelTooltip ? (labelTooltip | cxTranslate) : false) {
          <span
            class="aimo-icon icon-inline icon-info icon-sm"
            placement="top"
            ngbTooltip="{{ labelTooltip | cxTranslate }}"
          role="button"></span>
        }
      </label>
    }
    <div
      class="input-container"
            [ngClass]="{
                'input-container-icon': inputIcon,
                'icon-left': isLeftIcon && inputIcon,
                'icon-right': !isLeftIcon && inputIcon,
            }">
      @if (inputIcon && isLeftIcon) {
        <i class="aimo-icon icon-inline icon-sm input-icon {{ inputIcon }}"></i>
      }
      @if (showControls && typeInput === 'number') {
        <i
          (click)="decrement()"
          [ngClass]="{ 'icon-disable': inputValue <= min }"
        class="control aimo-icon icon-inline icon-sm icon-minus"></i>
      }
      @if (!isTextArea && !disabled) {
        <input
          #inputElement
          (blur)="onBlur($event)"
          (focus)="onFocus($event)"
          (mouseout)="onMouseOut($event)"
          (change)="onChange($event)"
          (input)="onInputChange($event.target.value)"
          (keydown.enter)="onEnter($event.target.value)"
          (keyup)="onKeypress($event)"
          [ngClass]="{ 'with-controls': showControls }"
                [attr.aria-label]="
                    arialLabel ? (arialLabel | cxTranslate) : placeholder ? (placeholder | cxTranslate) : ''
                "
          [attr.required]="isRequired() ? 'required' : null"
          aria-required="{{ isRequired() }}"
          class="form-control aimo-input mb-0 {{ inputClass }}"
          formControlName="{{ nameForm }}"
          id="{{ idName }}"
          [readOnly]="readOnly"
          [max]="max"
          [maxLength]="maxlength"
          name="{{ nameForm }}"
          placeholder="{{ placeholder ? (placeholder | cxTranslate) : '' }}"
          type="{{ typeInput ? typeInput : 'text' }}" />
      }
      @if (showControls && typeInput === 'number') {
        <i
          (click)="increment()"
          [ngClass]="{ 'icon-disable': inputValue >= max }"
        class="control aimo-icon icon-inline icon-sm icon-plus"></i>
      }
      @if (isTextArea && !disabled) {
        <textarea
          #inputElement
          (blur)="onBlur($event)"
          (focus)="onFocus($event)"
          (change)="onChange($event)"
          (mouseout)="onMouseOut($event)"
          (input)="onInputChange($event.target.value)"
          (keydown.enter)="onEnter($event.target.value)"
          (keypress)="onKeypress($event)"
                [attr.aria-label]="
                    arialLabel ? (arialLabel | cxTranslate) : placeholder ? (placeholder | cxTranslate) : ''
                "
          [attr.required]="isRequired() ? 'required' : null"
          aria-required="{{ isRequired() }}"
          class="form-control aimo-textarea {{ inputClass }}"
          formControlName="{{ nameForm }}"
          id="{{ idName }}"
          [readOnly]="readOnly"
          [maxLength]="maxlength"
          name="{{ nameForm }}"
        placeholder="{{ placeholder ? (placeholder | cxTranslate) : '' }}"></textarea>
      }
      @if (inputIcon && !isLeftIcon) {
        <i
          class="aimo-icon icon-inline icon-sm input-icon {{ inputIcon }}"
        (click)="onIconClick($event)"></i>
      }
    </div>
    @if (disabled && !nonEditable) {
      <p
        class="disabled-input-value aimo-input {{ inputClass }}"
            [ngClass]="{
                'input-container-icon': disabledIcon,
                'icon-left': isLeftIcon && disabledIcon,
                'icon-right': !isLeftIcon && disabledIcon,
            }">
        <span>
          {{
          typeInput === 'password'
          ? '&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;'
          : nameForm.value || '---'
          }}
        </span>
        @if (!isTextArea && disabledIcon) {
          <i
            (click)="onDisabledActionIcon()"
          class="aimo-icon icon-inline icon-sm input-icon {{ disabledIcon }}"></i>
        }
      </p>
    }
    @if (nonEditable) {
      <p
        class="non-editable-input-value aimo-input {{ inputClass }}"
            [ngClass]="{
                'input-container-icon': disabledIcon,
                'icon-left': isLeftIcon && disabledIcon,
                'icon-right': !isLeftIcon && disabledIcon,
            }">
        <span>
          {{
          typeInput === 'password'
          ? '&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;'
          : nameForm.value || '---'
          }}
        </span>
        @if (!isTextArea && disabledIcon) {
          <i
            (click)="onDisabledActionIcon()"
          class="aimo-icon icon-inline icon-sm input-icon {{ disabledIcon }}"></i>
        }
      </p>
    }
    @if (hint) {
      <p class="input-hint">{{ hint }}</p>
    }
  </div>
} @else {
  <div
    [class.is-invalid]="isNotValidFunction !== undefined ? isNotValidFunction : false"
    class="input-group input-label {{ hasValue() ? 'has-value' : '' }} {{ componentClass }}"
    [ngClass]="{ range: showControls && typeInput === 'number' }">
    @if (label) {
      <label
        for="{{ idName }}"
        class="input-label-value {{ labelClass }}"
        [ngClass]="{ required: isRequired() }">
        {{ label | cxTranslate }}
        @if (label && subLabel) {
          <span class="input-sublabel-value">{{ subLabel | cxTranslate }}</span>
        }
        @if (labelTooltip ? (labelTooltip | cxTranslate) : false) {
          <span
            class="aimo-icon icon-inline icon-info icon-sm"
            placement="top"
            ngbTooltip="{{ labelTooltip | cxTranslate }}"
          role="button"></span>
        }
      </label>
    }
    <div
      class="input-container"
            [ngClass]="{
                'input-container-icon': inputIcon,
                'icon-left': isLeftIcon && inputIcon,
                'icon-right': !isLeftIcon && inputIcon,
            }">
      @if (inputIcon && isLeftIcon) {
        <i class="aimo-icon icon-inline icon-sm input-icon {{ inputIcon }}"></i>
      }
      @if (showControls && typeInput === 'number') {
        <i
          (click)="decrement()"
          [ngClass]="{ 'icon-disable': inputValue <= min }"
        class="control aimo-icon icon-inline icon-sm icon-minus"></i>
      }
      @if (!isTextArea && !disabled) {
        <input
          #inputElement
          (blur)="onBlur($event)"
          (focus)="onFocus($event)"
          (change)="onChange($event)"
          (mouseout)="onMouseOut($event)"
          (input)="onInputChange($event.target.value)"
          (keydown.enter)="onEnter($event.target.value)"
          (keypress)="onKeypress($event)"
          [ngClass]="{ 'with-controls': showControls }"
                [attr.aria-label]="
                    arialLabel ? (arialLabel | cxTranslate) : placeholder ? (placeholder | cxTranslate) : ''
                "
          [attr.required]="isRequired() ? 'required' : null"
          aria-required="{{ isRequired() }}"
          class="form-control aimo-input {{ inputClass }}"
          id="{{ idName }}"
          [max]="max"
          [maxLength]="maxlength"
          name="{{ nameForm }}"
          placeholder="{{ placeholder ? (placeholder | cxTranslate) : '' }}"
          type="{{ typeInput ? typeInput : 'text' }}"
          value="{{ inputValue }}" />
      }
      @if (showControls && typeInput === 'number') {
        <i
          (click)="increment()"
          [ngClass]="{ 'icon-disable': inputValue >= max }"
        class="control aimo-icon icon-inline icon-sm icon-plus"></i>
      }
      @if (isTextArea && !disabled) {
        <textarea
          #inputElement
          rows="{{ rows }}"
          cols="{{ cols }}"
          (blur)="onBlur($event)"
          (focus)="onFocus($event)"
          (change)="onChange($event)"
          (mouseout)="onMouseOut($event)"
          (input)="onInputChange($event.target.value)"
          (keydown.enter)="onEnter($event.target.value)"
          (keypress)="onKeypress($event)"
                [attr.aria-label]="
                    arialLabel ? (arialLabel | cxTranslate) : placeholder ? (placeholder | cxTranslate) : ''
                "
          [attr.required]="isRequired() ? 'required' : null"
          aria-required="{{ isRequired() }}"
          class="form-control aimo-textarea {{ inputClass }}"
          id="{{ idName }}"
          [readOnly]="readOnly"
          [maxLength]="maxlength"
          name="{{ nameForm }}"
          placeholder="{{ placeholder ? (placeholder | cxTranslate) : '' }}"
        value="{{ inputValue }}"></textarea>
      }
      @if (inputIcon && !isLeftIcon) {
        <i
          class="aimo-icon icon-inline icon-sm input-icon {{ inputIcon }}"
        (click)="onIconClick($event)"></i>
      }
    </div>
    @if (disabled && !nonEditable) {
      <p
        class="disabled-input-value aimo-input {{ inputClass }}"
            [ngClass]="{
                'input-container-icon': disabledIcon,
                'icon-left': isLeftIcon && disabledIcon,
                'icon-right': !isLeftIcon && disabledIcon,
            }">
        <span>
          {{
          typeInput === 'password'
          ? '&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;'
          : inputValue || '---'
          }} </span
          >@if (!isTextArea && disabledIcon) {
          <i
            (click)="onDisabledActionIcon()"
          class="aimo-icon icon-inline icon-sm input-icon {{ disabledIcon }}"></i>
        }
      </p>
    }
    @if (nonEditable) {
      <p
        class="non-editable-input-value aimo-input {{ inputClass }}"
            [ngClass]="{
                'input-container-icon': disabledIcon,
                'icon-left': isLeftIcon && disabledIcon,
                'icon-right': !isLeftIcon && disabledIcon,
            }">
        <span>
          {{
          typeInput === 'password'
          ? '&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;'
          : inputValue || '---'
          }} </span
          >@if (!isTextArea && disabledIcon) {
          <i
            (click)="onDisabledActionIcon()"
          class="aimo-icon icon-inline icon-sm input-icon {{ disabledIcon }}"></i>
        }
      </p>
    }
    @if (hint) {
      <p class="input-hint">{{ hint }}</p>
    }
  </div>
}


@if ((isNotValidFunction ? isNotValidFunction : isNotValid(nameForm)) && errorMessage) {
  <div
    class="invalid-feedback d-block text-right"
    >
    <span>{{ errorMessage | cxTranslate }}</span>
  </div>
}
@if (extraInfoBottom) {
  <div class="extra-info text-right">
    {{ extraInfoBottom | cxTranslate }}
  </div>
}
